import { Box, Accordion, AccordionSummary, AccordionDetails, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { CostEstimation } from "@tm/data/vouchers/costEstimations"
import { useState } from "react"
import WorksTable from "./components/WorksTable"
import { WorksTotals } from "../totals/WorksTotals"

type Props = {
    costEstimation?: CostEstimation
}

export default function Works({ costEstimation }: Props) {
    const { works, repairTimeDivision, totalsB2B, totalsB2C, currencyCode, currencySymbol, costEstimationOptions } = costEstimation || {}
    const { translateText } = useLocalization()
    const [expanded, setExpanded] = useState(true)

    const showRepairTimesInHours = repairTimeDivision === 1
    return (
        <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)} disableGutters>
            <AccordionSummary sx={{ pl: 1 }}>
                <Typography variant="h4">{translateText(1668)}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box px={2} pb={1}>
                    <WorksTable
                        showRepairTimesInHours={showRepairTimesInHours}
                        works={works}
                        currencyCode={currencyCode}
                        currencySymbol={currencySymbol}
                    />
                    <Box py={1} pr={1} display="flex" justifyContent="flex-end">
                        <WorksTotals
                            priceVatMode={costEstimationOptions?.priceVatMode}
                            currencyCode={currencyCode ?? ""}
                            showRepairTimesInHours={showRepairTimesInHours}
                            totals={totalsB2B ?? totalsB2C}
                        />
                    </Box>
                </Box>
            </AccordionDetails>
        </Accordion>
    )
}
